// youtube player characteristics - different from editor, because there are no controls
var playerConfig = {
  modestBranding: false,
  controls: false,
  info: true,
  related: true
}

export default playerConfig
